"use client";
import { IBlocks, IBlog, IBlogPost, IUserData } from "@/types";
import React from "react";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import { BlogPostSkeletonBlock } from "@/components/admin/blog/skeleton";
import PostList from "@/components/admin/blog/PostList";
import BlockClickHandler from "./utils/click";
import { cn } from "@/lib/utils";
import {
    BORDER_RADIUS_OPTIONS,
    SHADOW_OPTIONS,
} from "./utils/block-style-classes";
interface Props {
    edit?: boolean;
    account: IUserData;
    block: IBlocks;
    update?: BlockUpdateFunction;
    theme: IUserData["chosen_theme"];
}
export default function BlockBlogPostSingle({
    edit,
    account,
    block,
    update,
    theme,
}: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    const [blog, setBlog] = React.useState<IBlog | null>(null);
    const [post, setPost] = React.useState<IBlogPost | null>(null);
    const [isLoading, setIsLoading] = React.useState(true);
    React.useEffect(() => {
        async function getPost() {
            if (blockUpdate.options?.post_id) {
                const res = await fetch(
                    `/api/account/${account.id}/post/${blockUpdate.options?.post_id}`
                );
                const post = await res.json();
                if (post.data) {
                    setPost(post.data.post);
                    setBlog(post.data.blog);
                    setIsLoading(false);
                }
            }
        }
        getPost();
    }, [blockUpdate.options?.post_id, account.id]);
    return (
        <AdminPopover
            edit={edit}
            className={block.show ? "" : "opacity-30"}
            title={"Blog Post Single"}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            <div
                key={block.id}
                className={cn(
                    `relative flex w-full flex-row flex-wrap gap-2 p-2`,
                    BORDER_RADIUS_OPTIONS[theme.profile.design.corner_radius]
                        ?.class,
                    SHADOW_OPTIONS[theme.profile.design.shadow]?.class,
                    "block-" + block.id
                )}
                id="BlogPostSingle"
                onClick={(e) => {
                    BlockClickHandler(account, e, block);
                }}
                onAuxClick={(e) => {
                    BlockClickHandler(account, e, block);
                }}
            >
                {isLoading && <BlogPostSkeletonBlock account={account} />}
                {!isLoading && blog && post && (
                    <PostList
                        blog={blog}
                        assets={[]}
                        post={{
                            ...post,
                            category_name:
                                blog.categories.find(
                                    (e) => e.id == post.category
                                )?.name || "",
                        }}
                        account={account}
                        accountTheme={{
                            ...account.theme,
                            text_col_button: theme.profile.colors.primary_text,
                            button: theme.profile.colors.primary,
                        }}
                        v2Theme={theme.profile as any}
                    />
                )}
            </div>
        </AdminPopover>
    );
}
